<template>
  <div class="welcome-card">
    <div class="card-content">
      <div class="decoration-top">
        <div class="confetti"></div>
        <div class="confetti"></div>
        <div class="confetti"></div>
      </div>
      <h2 class="title-welcome">Hai, Teman-teman!</h2>
      <div class="icon-container">
        <span class="emoji">📋</span>
        <span class="emoji">⏳</span>
        <span class="emoji">🎉</span>
      </div>
      <p class="subtitle">
        Saat ini kami sedang memproses data registrasi yang sudah masuk.<br><br>
        <span class="highlight">Belum registrasi?</span> Tenang saja, kamu masih bisa mendaftar langsung di hari acara!<br><br>
        <strong class="cta">See you on Petra Parade! ✨</strong>
      </p>
      <div class="decoration-bottom">
        <div class="wave"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.welcome-card {
  background: linear-gradient(135deg, #f5f7fa 0%, #aacce1 100%);
  border-radius: 28px;
  padding: 2.5rem;
  width: 100%;
  max-width: 580px;
  box-shadow: 0 15px 50px rgba(234, 82, 139, 0.2);
  text-align: center;
  margin: 10vh auto 0 auto;
  position: relative;
  overflow: hidden;
  border: none;
}

.card-content {
  position: relative;
  z-index: 2;
}

.title-welcome {
  color: #649acf;
  margin-bottom: 1.5rem;
  font-size: 2.2rem;
  font-weight: 700;
  text-shadow: 1px 1px 3px rgba(0,0,0,0.1);
}

.subtitle {
  color: #3a6c9e;
  font-size: 1.2rem;
  line-height: 1.7;
  white-space: pre-line;
  margin: 1.5rem 0;
}

.highlight {
  background-color: #ea528b;
  padding: 0.2rem 0.5rem;
  border-radius: 6px;
  font-weight: 600;
  color: #ffffff;
}

.cta {
  display: inline-block;
  margin-top: 1.5rem;
  padding: 0.8rem 2rem;
  background: linear-gradient(135deg, #ea528b 0%, #ff7e5f 100%);
  color: white;
  border-radius: 40px;
  font-weight: 700;
  text-decoration: none;
  box-shadow: 0 5px 15px rgba(234, 82, 139, 0.4);
  transition: transform 0.3s;
}
.cta:hover{
  transform: translateY(-3px);
}

.icon-container {
  margin: 1rem 0;
}

.emoji {
  font-size: 2rem;
  margin: 0 0.5rem;
  display: inline-block;
  animation: bounce 3s infinite alternate;
}

.emoji:nth-child(2) {
  animation-delay: 0.3s;
}

.emoji:nth-child(3) {
  animation-delay: 0.6s;
}

.decoration-top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px;
  overflow: hidden;
}

.confetti {
  position: absolute;
  width: 12px;
  height: 12px;
  background-color: #ffd166;
  border-radius: 50%;
  animation: confetti-fall 5s linear infinite;
}

.confetti:nth-child(1) {
  left: 10%;
  animation-delay: 0s;
  background-color: #ffd166;
}

.confetti:nth-child(2) {
  left: 50%;
  animation-delay: 1.5s;
  background-color: #06d6a0;
}

.confetti:nth-child(3) {
  left: 80%;
  animation-delay: 2.5s;
  background-color: #118ab2;
}

.decoration-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30px;
  overflow: hidden;
}

.wave {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 200%;
  height: 100%;
  background: url('data:image/svg+xml;utf8,<svg viewBox="0 0 1200 120" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none"><path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" fill="%23ea528b" opacity=".1"/></svg>');
  background-repeat: repeat-x;
  animation: wave 10s linear infinite;
}

@keyframes bounce {
  0% { transform: translateY(0); }
  100% { transform: translateY(-15px); }
}

@keyframes confetti-fall {
  0% { transform: translateY(-20px) rotate(0deg); opacity: 1; }
  100% { transform: translateY(300px) rotate(360deg); opacity: 0; }
}

@keyframes wave {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

@media (max-width: 768px) {
  .welcome-card {
    width: 90%;
    padding: 2rem 1.5rem;
    border-radius: 24px;
  }
  
  .title-welcome {
    font-size: 1.8rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
  
  .cta {
    font-size: 1.1rem;
    padding: 0.6rem 1.2rem;
  }
  
  .emoji {
    font-size: 1.8rem;
  }
}
</style>